import { render, staticRenderFns } from "./MdmVideo.vue?vue&type=template&id=57d6b9a1&name=mdm-video&"
import script from "./MdmVideo.vue?vue&type=script&lang=js&"
export * from "./MdmVideo.vue?vue&type=script&lang=js&"
import style0 from "./MdmVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports